<template>
  <div class="charge-breakdown-mask" @click.self="$emit('close')">
    <div class="charge-breakdown" role="dialog" aria-modal="true" :aria-labelledby="titleId" @click.stop>
      <div class="charge-breakdown__header">
        <h2 :id="titleId" class="charge-breakdown__title">
          {{ $t("assistantCatHome.chargeBreakdownDialog.title") }}
        </h2>
        <button
          type="button"
          class="charge-breakdown__icon-close"
          :aria-label="$t('common.close')"
          @click="$emit('close')"
        >
          <icon-close />
        </button>
      </div>
      <div class="charge-breakdown__section">
        <p class="charge-breakdown__label">{{ $t("assistantCatHome.chargeBreakdownDialog.chargeWeb") }}</p>
        <div class="charge-breakdown__amount">
          <img src="@/assets/img/icon/fish_icon.png" :alt="$t('purchaseFish.product.fishIcon')" />
          <span>{{ webChargeLabel }}</span>
        </div>
      </div>
      <button type="button" class="charge-breakdown__close" @click="$emit('close')">
        {{ $t("common.close") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import IconClose from "~icons/figma/Close";

export default Vue.extend({
  name: "AssistantCatHomeChargeBreakdownDialog",
  components: {
    IconClose,
  },
  props: {
    webChargeLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      titleId: "assistant-cat-home-charge-breakdown-title",
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.charge-breakdown-mask {
  position: fixed;
  inset: 0;
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-overlay);
}

.charge-breakdown {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 300px;
  max-width: calc(100% - 32px);
  overflow: hidden;
  background: var(--color-background-normal);
  border-radius: var(--radius-lg);
  color: var(--color-text-normal);
}

.charge-breakdown__header {
  position: relative;
  padding: 12px 12px 4px;
}

.charge-breakdown__title {
  margin: 0;
  color: var(--color-text-normal);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-default);
  text-align: center;
}

.charge-breakdown__icon-close {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-normal);
  cursor: pointer;

  ::v-deep .figma-icon {
    width: 20px;
    height: 20px;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-focus-ring);
    border-radius: var(--radius-sm);
  }
}

.charge-breakdown__section {
  padding: 12px 20px;

  & + & {
    border-top: 1px solid var(--color-border);
  }
}

.charge-breakdown__label {
  margin: 0 0 8px;
  color: var(--color-text-low);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-default);
}

.charge-breakdown__amount {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-text-normal);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-default);

  img {
    width: 24px;
    height: 24px;
  }
}

.charge-breakdown__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  padding: 0;
  border: none;
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  background: transparent;
  color: var(--color-text-low);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  cursor: pointer;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-focus-ring);
  }
}
</style>
